import * as React from "react"
import { SvgComponentProps } from "../types/SVGPropType"
const ArrowRight2SVG: React.FC<SvgComponentProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ? props.width : 15}
    height={props.width ? props.width - 2 : 13}
    fill="none"
    viewBox="0 0 20 13"
    {...props}
  >
    <path
      fill="#F5F6F7"
      fillRule="evenodd"
      d="m9.499.72-.53-.53-1.061 1.06.53.53 3.97 3.97H.968v1.5h11.44l-3.97 3.97-.53.53 1.06 1.06.531-.53 5.073-5.073a1 1 0 0 0 0-1.414L9.5.72Z"
      clipRule="evenodd"
    />
  </svg>
)
export default ArrowRight2SVG
